import { createApiHook, useApi } from "../utils/apiUtils";

const TTL = 300000; // 5 minutos en milisegundos

const useFetchUsers = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook([]);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const getUsers = async (forceRefresh = false) => {
    startLoading();
    // Variable local para trabajar con el flag de refresco
    let shouldForceRefresh = forceRefresh;
    if (!shouldForceRefresh) {
      const storedTimeStr = localStorage.getItem("forceRefreshUsers");
      if (storedTimeStr) {
        const storedTime = parseInt(storedTimeStr, 10);
        const now = Date.now();
        if (now - storedTime < TTL) {
          // Durante el período TTL, se forzará la actualización
          shouldForceRefresh = true;
        } else {
          // Se remueve el flag si ya expiró para llamadas futuras
          localStorage.removeItem("forceRefreshUsers");
        }
      }
    }
    const url = shouldForceRefresh ? `/users/index_with_roles?refresh=${new Date().getTime()}` : `/users/index_with_roles`;
    const response = await apiGet(url, "Error al obtener usuarios");
    setResponse(response);
  };
  return { getUsers, data, loading, error };
};

export default useFetchUsers;
